import React from 'react';
import SectionWrapper from '../../../../components/sectionWrapper/sectionWrapper';
import { APP_STORE_URL } from '../../constants';
import { styles } from './styles';

export default function Download(): JSX.Element {

  return (
    <SectionWrapper
      id="download"
      label="Download"
      heading={APP_STORE_URL ? 'Get PlayerCafe' : 'Coming soon'}
     
    >
      <div className="pc-split" style={styles.grid}>
        <div style={styles.panel}>
          <span style={styles.platform}>iPhone</span>
          {APP_STORE_URL ? (
            <a href={APP_STORE_URL} style={styles.storeLink}>Download on the App Store</a>
          ) : (
            <span style={styles.status}>Coming soon to the App Store</span>
          )}
          <p style={styles.detail}>
            Free, with ads. When you run out of requests for the day, you can watch an ad for 10 more.
          </p>
        </div>
        <div style={styles.panel}>
          <span style={styles.platform}>Android</span>
          <span style={styles.status}>Coming to Android</span>
          <p style={styles.detail}>The Android version comes after the iPhone launch.</p>
        </div>
      </div>
    </SectionWrapper>
  );

}
